import { AssociationFileBrowser } from "@/shared/components/AssociationFileBrowser";
import { useDataset } from "@/shared/domain/datasets/hooks";
import { Goto } from "@/shared/navigation";

import { useDatasetContext } from "../useDatasetContext";

/**
 * Files tab of the dataset detail view. The dataset comes from the
 * `:datasetPath` parent route, and the open folder from the `files/*` child
 * route.
 */
export function DatasetFileBrowser() {
  const { datasetId } = useDatasetContext();
  const { data: dataset } = useDataset(datasetId);

  return (
    <AssociationFileBrowser
      associationId={datasetId}
      // The dataset's org, not the viewer's: a dataset of another org records
      // uploads under its own org. No uploads until it is known.
      orgId={dataset?.org_id}
      rootUrl={`${Goto.createDatasetRoute(datasetId)}/files`}
      rootLabel={datasetId}
      parentCrumbs={[{ label: "Datasets", to: Goto.route.Datasets }]}
    />
  );
}
